import { render } from "./RangeShortcuts.vue?vue&type=template&id=03bb6169&scoped=true&bindings={\"modelValue\":\"props\",\"color\":\"props\",\"dark\":\"props\",\"dateTime\":\"props\",\"customShortcuts\":\"props\",\"height\":\"props\",\"computedTypes\":\"data\",\"selectedShortcut\":\"data\",\"init\":\"options\",\"noticeDeprecation\":\"options\",\"getShortcutByKey\":\"options\",\"select\":\"options\"}"
import script from "./RangeShortcuts.vue?vue&type=script&lang=js"
export * from "./RangeShortcuts.vue?vue&type=script&lang=js"

import "./RangeShortcuts.vue?vue&type=style&index=0&id=03bb6169&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-03bb6169"

export default script